/** Nest `GlobalExceptionFilter` puts `HttpException.getResponse()` JSON into `detail`. */
export function parseProblemDetailsDetail(detail: string | undefined): string | undefined {
  if (!detail?.trim()) {
    return undefined;
  }
  try {
    const parsed = JSON.parse(detail) as { message?: string | string[] };
    if (Array.isArray(parsed.message)) {
      return parsed.message.filter(Boolean).join(' ');
    }
    if (typeof parsed.message === 'string') {
      return parsed.message;
    }
  } catch {
    // plain string detail
    if (!detail.trimStart().startsWith('{')) {
      return detail;
    }
  }
  return undefined;
}
